import { useSelector } from "react-redux"

const LoyaltyScheme = () => {



    const state = useSelector(state => state.ourAlumniCommunity)
    const ourAlumni = state?.data?.properties

    const title = ourAlumni?.thirdMainTitle
    const description = ourAlumni?.thirdMainDescription
    const description2 = ourAlumni?.thirdMainDecription2

    const cards = ourAlumni?.advantagesRow2?.items?.map((item) => {
        return item?.content?.properties?.title
    })

    return (
        <div className="flex justify-center lg:py-8">
            <div className="lg:shadow-lg p-2 md:p-8 ">
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-4 p-6">
                        <h1 className="w-auto  text-slate-900 text-3xl md:text-5xl font-bold ">{title}</h1>
                        <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">{description}</p>
                        <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-bold leading-normal">{description2}</p>
                    </div>
                    <div
                        className="flex items-center justify-center p-4 border lg:border-0 rounded-lg shadow-md hover:shadow-lg transition duration-300 ease-in-out my-5">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-4 ">
                            {
                                cards?.map((card, index) => (
                                    <div
                                        className={`flex flex-col items-center  max-w-[25rem] gap-4 p-4 ${index < (cards?.length - 1) && "border-b sm:border-b-0 sm:border-r border-dashed border-gray-300"} `}
                                        key={index}>
                                        <h2 className="w-auto  text-slate-900 text-lg text-center font-extrabold ">{card}</h2>
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default LoyaltyScheme